import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { UserRole } from '../../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;
  requiredRoles?: UserRole[];
}

const centeredScreen: React.CSSProperties = {
  minHeight: '100vh', display: 'flex', alignItems: 'center',
  justifyContent: 'center', background: '#f4efe2',
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  requiredRoles
}) => {
  const { isAuthenticated, user, loading } = useAuthStore();
  const location = useLocation();

  if (loading) {
    return (
      <div style={centeredScreen}>
        <div style={{
          width: 48, height: 48, borderRadius: '50%',
          border: '2px solid transparent',
          borderTopColor: '#d97706',
          animation: 'spin 0.8s linear infinite',
        }} />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return (
      <div style={centeredScreen}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontFamily: "'Inter', sans-serif", fontSize: 28, fontWeight: 300, color: '#1c2033', marginBottom: 12 }}>
            Access Denied
          </h1>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: '#6b6a5c' }}>
            You don't have permission to access this page.
          </p>
        </div>
      </div>
    );
  }

  if (requiredRoles && !requiredRoles.includes(user.role)) {
    return (
      <div style={centeredScreen}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontFamily: "'Inter', sans-serif", fontSize: 28, fontWeight: 300, color: '#1c2033', marginBottom: 12 }}>
            Access Denied
          </h1>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: '#6b6a5c' }}>
            You don't have permission to access this page.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
